import React from "react";
import Img from "../../images/invite.png"
const Invitefriend =()=>{
    return(
        <div className="pt-3 pb-3">
            
          <img className="invitefrndimg" src={Img}></img>
        </div>
    )
}
export default Invitefriend;